import React, { useState, useEffect } from "react";
import styled from "styled-components";

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: ${(props) =>
    props.$scrolled ? "rgba(0, 0, 0, 0.95)" : "rgba(0, 0, 0, 0.1)"};
  backdrop-filter: blur(10px);
  border-bottom: ${(props) =>
    props.$scrolled ? "1px solid rgba(220, 38, 38, 0.3)" : "none"};
  transition: all 0.3s ease;
  z-index: 1000;
  padding: 0;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${(props) => (props.$scrolled ? "#dc2626" : "#fff")};
  transition: color 0.3s ease;
  cursor: pointer;

  &::before {
    content: "⚡";
    margin-right: 0.5rem;
    font-size: 1.8rem;
  }
`;

const LoginButton = styled.button`
  background: transparent;
  border: 2px solid ${(props) => (props.$scrolled ? "#dc2626" : "#fff")};
  color: ${(props) => (props.$scrolled ? "#dc2626" : "#fff")};
  padding: 0.75rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;

  &:hover {
    background: #dc2626;
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(220, 38, 38, 0.3);
  }

  @media (max-width: 768px) {
    padding: 0.5rem 1.5rem;
    font-size: 0.9rem;
  }
`;

const HeaderSimple = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogin = () => {
    window.location.href = "/login";
  };

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <HeaderContainer $scrolled={isScrolled}>
      <Nav>
        <Logo $scrolled={isScrolled} onClick={handleLogoClick}>
          beatt pulse
        </Logo>
        <LoginButton $scrolled={isScrolled} onClick={handleLogin}>
          Fazer Login
        </LoginButton>
      </Nav>
    </HeaderContainer>
  );
};

export default HeaderSimple;